import { h } from 'preact';
import Image from 'utils/image';
import clsx from 'clsx';
import { useMemo } from 'preact/hooks';
import { isLauraCanada } from 'utils/helpers';
import { useLocations } from './locations-context';
import ProductPrice from '../product/product-price';

const StoreProduct = ({ location }) => {
  const { currentProduct, currentVariant, stockData } = useLocations();

  if (!currentVariant) {
    return null;
  }

  const options = useMemo(
    () =>
      currentVariant.selectedOptions
        .filter((option) =>
          !isLauraCanada()
            ? option.name.trim().toLowerCase() !==
              window.TMW.Strings.product.options.fit
            : true,
        )
        .map((option) => option.value)
        .join(', '),
    [currentVariant],
  );

  return (
    <div className="mt-16 border-t border-grey-300 pt-16 flex gap-24">
      <div className="w-[82px] h-[110px] flex-none lc:rounded-4 overflow-hidden">
        <Image
          {...currentProduct.images[0]}
          srcWidths={{ sm: 640 }}
          classes="object-cover h-full w-full"
        />
      </div>
      <div className="flex flex-col flex-1 gap-4">
        <div className="body-1">{currentProduct.title}</div>
        <ProductPrice
          product={currentProduct}
          className="[&_.price]:product-card-price ml:text-left flex flex-wrap gap-x-4 items-center ml:justify-start"
          saleClass="text-misc-sale body-3"
          compareClass="product-card-price--compare text-subdued"
        />
        <div className="body-2 text-subdued">{options}</div>
        {!!stockData && (
          <div className="flex items-center gap-4 ">
            <div
              className={clsx('w-8 h-8 ml:w-5 ml:h-5 rounded-full', {
                'bg-misc-green': stockData[location.storeId] > 1,
                'bg-misc-yellow': stockData[location.storeId] === 1,
                'bg-misc-sale ml:bg-error':
                  !stockData[location.storeId] ||
                  stockData[location.storeId] < 1,
              })}
            ></div>
            <div className="body-3 text-subdued">
              {stockData[location.storeId] > 1
                ? window.TMW.Strings.storeLocator.inStock
                : stockData[location.storeId] === 1
                ? window.TMW.Strings.storeLocator.lowStock
                : window.TMW.Strings.storeLocator.outOfStock}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreProduct;
